import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { TypeManagerDecorator } from "../../../../main/type.map.service";
import { S25ButtonComponent } from "../../../../standalone/s25.button.component";

/**
 * A payment history cell that reads as text, offers an action, or does both - the Type, Status and
 * Void columns all take that shape, differing only in what they say and what they let you do.
 */
@TypeManagerDecorator("s25-ng-payment-action-cell")
@Component({
    selector: "s25-ng-payment-action-cell",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25ButtonComponent],
    template: `
        <div class="action-cell">
            @if (text()) {
                <span class="action-text">{{ text() }}</span>
            }
            @if (actionLabel()) {
                <s25-ng-button [type]="actionType()" [onClick]="onAction()">{{ actionLabel() }}</s25-ng-button>
            }
        </div>
    `,
    styles: `
        .action-cell {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 6px;
        }

        .action-text {
            overflow-wrap: anywhere;
        }
    `,
})
export class S25PaymentActionCellComponent {
    readonly text = input("");
    readonly actionLabel = input("");
    readonly actionType = input<"outline" | "primary" | "danger">("outline");
    readonly onAction = input<() => Promise<void> | void>(() => {});
}
